<template>
    <span class="uik-content-title__wrapper">
        <slot></slot>
    </span>
</template>

<script>
export default {
    name: "UikContentTitle"
}
</script>

<style lang="scss">
.uik-content-title__wrapper {
  font-weight: 500;
  font-size: .75rem;
  color: $textSecondary;
  line-height: 1.125rem;
  text-transform: uppercase;
  &+* {
    margin-top: .5rem;
  }
}
</style>
